module.exports = __webpack_public_path__ + "static/img/el-tenedor-rosa-2.9c03d1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/el-tenedor-rosa-2.jpg
// module id = nhLy
// module chunks = 1